import React, { useEffect } from 'react';
import { auth } from '../../firebase/firebase-config';
import { markNoticeAsRead } from '../../services/noticesService';
import ContentAttachmentsActions from '../../platform/ContentAttachmentsActions';
import ContentDetailHero from '../../platform/ContentDetailHero';
import ContentUnitTag from '../common/ContentUnitTag';
import {
  isDetailHeroEnabled,
  PREMIUM_MODULE_IDS,
  premiumDetailClassName,
} from '../../platform/contentListVisual';

function formatDate(date) {
  if (!date) return '';
  const value = date instanceof Date ? date : new Date(date);
  return value.toLocaleString('sl-SI', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function NoticeDetail({ notice, unitNames = {} }) {
  const useHero = isDetailHeroEnabled(PREMIUM_MODULE_IDS.NOTICES);

  useEffect(() => {
    const markAsRead = async () => {
      if (auth.currentUser?.uid) {
        await markNoticeAsRead(auth.currentUser.uid, notice.id);
      }
    };

    markAsRead();
  }, [notice.id]);

  const meta = (
    <>
      <span>Ustvaril {notice.displayName || 'Anonimen'}</span>
      {notice.createdAt && (
        <>
          <span className="platform-content-detail-hero__meta-separator">·</span>
          <span>{formatDate(notice.createdAt)}</span>
        </>
      )}
    </>
  );

  return (
    <article className={premiumDetailClassName(PREMIUM_MODULE_IDS.NOTICES, 'notice-detail platform-content-detail')}>
      <div className="platform-content-detail-shell">
        {useHero ? (
          <ContentDetailHero
            title={notice.title}
            imageUrl={notice.thumbnailUrl}
            badges={<ContentUnitTag item={notice} unitNames={unitNames} />}
            meta={meta}
          />
        ) : null}

        <div className="platform-content-detail-card">
          {!useHero && (
            <div className="platform-content-detail-card__header">
              <h2 className="platform-content-detail-card__title">Obvestilo</h2>
            </div>
          )}

          <div className="platform-content-detail__body">
            {!useHero && (
              <div className="platform-content-detail__meta">
                <ContentUnitTag item={notice} unitNames={unitNames} />
                <span className="platform-content-detail__meta-separator">·</span>
                <span>Ustvaril {notice.displayName || 'Anonimen'}</span>
                {notice.createdAt && (
                  <>
                    <span className="platform-content-detail__meta-separator">·</span>
                    <span>{formatDate(notice.createdAt)}</span>
                  </>
                )}
              </div>
            )}

            <div
              className="platform-content-detail__content"
              dangerouslySetInnerHTML={{ __html: notice.text }}
            />

            <ContentAttachmentsActions item={notice} className="platform-content-detail__actions" />
          </div>
        </div>

        {!useHero && notice.thumbnailUrl && (
          <div className="platform-content-detail-card">
            <div className="platform-content-detail-card__header">
              <h2 className="platform-content-detail-card__title">Slika</h2>
            </div>
            <div className="platform-content-detail__media platform-content-detail__media--bottom">
              <img src={notice.thumbnailUrl} alt="" loading="lazy" />
            </div>
          </div>
        )}
      </div>
    </article>
  );
}

export default NoticeDetail;
